import { error, log } from '../../utils/logger.js';

var WinStoreCallbacks;
(function (WinStoreCallbacks) {
    WinStoreCallbacks["OnProductReceived"] = "OnProductReceived";
    WinStoreCallbacks["OnAllProductsReceived"] = "OnAllProductsReceived";
    WinStoreCallbacks["OnReceiveFailed"] = "OnReceiveFailed";
    WinStoreCallbacks["onAccountDataAvailable"] = "onAccountDataAvailable";
    WinStoreCallbacks["OnPurchaseSucceed"] = "OnPurchaseSucceed";
    WinStoreCallbacks["OnPurchaseFailed"] = "OnPurchaseFailed";
    WinStoreCallbacks["OnUserCountryReceived"] = "OnUserCountryReceived";
})(WinStoreCallbacks || (WinStoreCallbacks = {}));
class WinStoreCallbackObserver {
    constructor() {
        this.callbacks = {};
        this.products = [];
        this.init();
    }
    init() {
        window.winStore = new Proxy({}, {
            get: (target, property) => {
                return (...args) => {
                    var _a, _b;
                    (_b = (_a = this === null || this === void 0 ? void 0 : this[property]) === null || _a === void 0 ? void 0 : _a.apply) === null || _b === void 0 ? void 0 : _b.call(_a, this, args);
                };
            }
        });
    }
    emit(name, ...payload) {
        if (this.callbacks[name]) {
            this.callbacks[name].forEach((callback) => {
                callback(...payload);
            });
            delete this.callbacks[name];
        }
    }
    OnProductReceived(product) {
        if (!product) {
            error('OnProductReceived', 'Empty product payload');
            throw new Error('Empty product payload');
        }
        this.products.push(product);
        this.emit(WinStoreCallbacks.OnProductReceived);
    }
    OnAllProductsReceived() {
        log('OnAllProductsReceived', this.products);
        this.emit(WinStoreCallbacks.OnAllProductsReceived, this.products);
    }
    OnReceiveFailed(error, code) {
        this.emit(WinStoreCallbacks.OnReceiveFailed, error, code);
    }
    onAccountDataAvailable(accountMatchStatus) {
        this.emit(WinStoreCallbacks.onAccountDataAvailable, accountMatchStatus);
    }
    OnPurchaseSucceed(transactionId, inAppOfferToken) {
        this.emit(WinStoreCallbacks.OnPurchaseSucceed, transactionId, inAppOfferToken);
    }
    OnPurchaseFailed(error, code) {
        this.emit(WinStoreCallbacks.OnPurchaseFailed, error, code);
    }
    OnUserCountryReceived(country) {
        this.emit(WinStoreCallbacks.OnUserCountryReceived, country);
    }
    once(name, callback) {
        if (!this.callbacks[name]) {
            this.callbacks[name] = [];
        }
        this.callbacks[name].push(callback);
    }
}
var WinStoreCallbackObserver$1 = new WinStoreCallbackObserver();

export { WinStoreCallbacks, WinStoreCallbackObserver$1 as default };
//# sourceMappingURL=WinStoreCallbackObserver.js.map
